export enum MenuType {
  CAMPAIGN_BANNER = 'CAMPAIGN_BANNER',
  QUICK_MENU = 'QUICK_MENU',
  RECOMMENDED_BY_ADMIN = 'RECOMMENDED_BY_ADMIN',
  NOTICE = 'NOTICE',
  RECENT_INSTANT_LEARNING = 'RECENT_INSTANT_LEARNING',
  MY_INSTANT_LEARNING_PROGRESS_RATE = 'MY_INSTANT_LEARNING_PROGRESS_RATE',
  CHECKLIST = 'CHECKLIST',
  CREW_PULSE_ATTENDANCE_MANAGEMENT = 'CREW_PULSE_ATTENDANCE_MANAGEMENT',
  MY_COMMUNITY_ACTIVITY = 'MY_COMMUNITY_ACTIVITY',
  RECENT_DEGREE = 'RECENT_DEGREE',
  MY_ONLINE_CLASS_WEEKLY_ACHIEVEMENT = 'MY_ONLINE_CLASS_WEEKLY_ACHIEVEMENT',
  ATTENDANCE = 'ATTENDANCE',
  // PRODUCT MANAGEMENT
  PRODUCT_MANAGEMENT = 'PRODUCT_MANAGEMENT',
  EXPIRATION_UNTIL_TODAY = 'EXPIRATION_UNTIL_TODAY',
  ONE_DAY_BEFORE_EXPIRATION = 'ONE_DAY_BEFORE_EXPIRATION',
  WEEK_BEFORE_EXPIRATION = 'WEEK_BEFORE_EXPIRATION',
  // CREWPULSE
  CREW_PULSE_TO_DO = 'CREW_PULSE_TO_DO',
  CREW_PULSE_TO_DO_COMPLETED = 'CREW_PULSE_TO_DO_COMPLETED',
  CREW_PULSE_TO_DO_CHECKBOX = 'CREW_PULSE_TO_DO_CHECKBOX',

  // MY REWARD
  MY_PORTFOLIO = 'MY_PORTFOLIO',
  MY_PORTFOLIO_BOOKMARKED_LESSON = 'MY_PORTFOLIO_BOOKMARKED_LESSON',
  MY_PORTFOLIO_LIKED_LESSON = 'MY_PORTFOLIO_LIKED_LESSON',
  MY_PORTFOLIO_LIKED_INSTANT_LEARNING = 'MY_PORTFOLIO_LIKED_INSTANT_LEARNING',
  MY_PORTFOLIO_LIKED_SOCIAL_LEARNING = 'MY_PORTFOLIO_LIKED_SOCIAL_LEARNING',
  // (ADDED)
  MY_PORTFOLIO_BOOKMARKED_MISSION = 'MY_PORTFOLIO_BOOKMARKED_MISSION',
  MY_PORTFOLIO_ONLINE_DEGREE_QNA = 'MY_PORTFOLIO_ONLINE_DEGREE_QNA',
  MY_PORTFOLIO_EXAM_QUESTION_QNA = 'MY_PORTFOLIO_EXAM_QUESTION_QNA',
  MY_PORTFOLIO_QUESTION_ISSUE_RESULT = 'MY_PORTFOLIO_QUESTION_ISSUE_RESULT',
  MY_PORTFOLIO_BADGE = 'MY_PORTFOLIO_BADGE',
  MY_PORTFOLIO_CERTIFICATE = 'MY_PORTFOLIO_CERTIFICATE',

  // MY REWARD
  MY_REWARD = 'MY_REWARD',
  MY_REWARD_LEVEL = 'MY_REWARD_LEVEL',
  MY_REWARD_POINT = 'MY_REWARD_POINT',
  MY_REWARD_RANKING = 'MY_REWARD_RANKING',
  MY_REWARD_STORE_RANKING = 'MY_REWARD_STORE_RANKING',
}

export const LayoutTypeConstant = {
  LAYOUT_TYPE_A: 'A',
  LAYOUT_TYPE_B: 'B',
  LAYOUT_TYPE_C: 'C',
};

export const PaperStatusConstant = {
  SOLVING: 'SOLVING',
  SUBMITTED: 'SUBMITTED',
};

export const DegreeTypeConstant = {
  INSTANT_LEARNING: 'INSTANT_LEARNING',
  ONLINE_DEGREE: 'ONLINE_DEGREE',
};

export const QuickMenuTypeConstant = {
  ONLINE_CLASS: 'ONLINE_CLASS',
  INSTANT_LEARNING: 'INSTANT_LEARNING',
  SURVEY: 'SURVEY',
  MY_PORTFOLIO: 'MY_PORTFOLIO',
  MY_ONLINE_CLASS: 'MY_ONLINE_CLASS',
  MY_EXAM: 'MY_EXAM',
  LEADER_BOARD: 'LEADER_BOARD',
  MY_POINT: 'MY_POINT',
  MY_LEVEL: 'MY_LEVEL',
  SOCIAL_LEARNING_BOARD: 'SOCIAL_LEARNING_BOARD',
  COMMUNITY_BOARD: 'COMMUNITY_BOARD',
  GOODS_MANAGEMENT: 'GOODS_MANAGEMENT',
  CHECKLIST: 'CHECKLIST',
  CREWPULSE: 'CREWPULSE',
  MY_PAGE: 'MY_PAGE',
  INDEPENDENT_EXAM: 'INDEPENDENT_EXAM',
  SETTING: 'SETTING',
  REWARD: 'REWARD',
};

export enum LayoutType {
  TYPE_A,
  TYPE_B,
}

export const LearningStatusConstant = {
  WAITING: 'WAITING',
  LEARNING: 'LEARNING',
  COMPLETE: 'COMPLETE',
};

export const UserRoleConstant = {
  STORE_HEAD: 'STORE_HEAD',
};

export enum ClientType {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export const LocationType = {
  MAIN_PAGE: 'MAIN_PAGE',
};

export enum AttendanceType {
  ATTENDED = 'ATTENDED',
  NOT_ATTENDED = 'NOT_ATTENDED',
  NOT_YET = 'NOT_YET',
}

export enum CardSize {
  SMALL = 'SMALL',
  NORMAL = 'NORMAL',
}
export enum CellSize {
  GRID_2x1 = '2x1',
  GRID_2x2 = '2x2',
  GRID_2x2_6 = '2x2.6',
  GRID_4x1 = '4x1',
  GRID_4x2 = '4x2',
  GRID_4x3_15 = '4x3.15',
  GRID_4x2_5 = '4x2.5',
  GRID_4x2_6 = '4x2.6',
  GRID_4x3 = '4x3',
  GRID_4x3_2 = '4x3.2',
  GRID_4x3_5 = '4x3.5',
  GRID_4x4 = '4x4',
  GRID_8x2_6 = '8x2.6',
  GRID_8x4 = '8x4',
}

export enum CarouselWidgetThemeMode {
  DEFAULT = 'DEFAULT',
  SECONDARY = 'SECONDARY',
}
